"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const framer_motion_1 = require("framer-motion");
const CopyIcon_1 = __importDefault(require("../../../icons/CopyIcon"));
const OptionsIcon_1 = __importDefault(require("../../../icons/OptionsIcon"));
const ResetIcon_1 = __importDefault(require("../../../icons/ResetIcon"));
const useOnClickOutside_1 = __importDefault(require("../../../hooks/useOnClickOutside"));
const copyToClipboard_1 = __importDefault(require("../../../utils/copyToClipboard"));
const useToggle_1 = __importDefault(require("../../../hooks/useToggle"));
const inputOptions_module_scss_1 = __importDefault(require("./inputOptions.module.scss"));
const InputOptions = ({ value, disabled, onResetFieldClick }) => {
    const [areOptionsOpened, { setFalse: closeOptionsDropdown, toggle: toggleOptionsDropdown }] = (0, useToggle_1.default)(false);
    const ref = (0, react_1.useRef)(null);
    const handleCopyFieldDataClick = () => {
        (0, copyToClipboard_1.default)((value === null || value === void 0 ? void 0 : value.toString()) || '');
        closeOptionsDropdown();
    };
    (0, useOnClickOutside_1.default)(ref, closeOptionsDropdown);
    const inputOptions = [
        {
            text: 'Copy',
            icon: (0, jsx_runtime_1.jsx)(CopyIcon_1.default, {}, void 0),
            onClick: handleCopyFieldDataClick
        }
    ];
    if (!disabled) {
        inputOptions.unshift({
            text: 'Reset',
            icon: (0, jsx_runtime_1.jsx)(ResetIcon_1.default, {}, void 0),
            onClick: onResetFieldClick
        });
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: ref }, { children: [(0, jsx_runtime_1.jsx)("button", Object.assign({ type: "button", className: (0, classnames_1.default)(inputOptions_module_scss_1.default.input_options_button, {
                    [inputOptions_module_scss_1.default.input_options_button_active]: areOptionsOpened
                }), onClick: toggleOptionsDropdown }, { children: (0, jsx_runtime_1.jsx)(OptionsIcon_1.default, {}, void 0) }), void 0), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: areOptionsOpened && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.ul, Object.assign({ className: inputOptions_module_scss_1.default.input_options, initial: "hidden", animate: "visible", exit: "hidden", variants: inputOptionsVariants.ul }, { children: inputOptions.map(({ icon, text, onClick }, key) => ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.li, Object.assign({ className: inputOptions_module_scss_1.default.input_option, variants: inputOptionsVariants.li }, { children: (0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: inputOptions_module_scss_1.default.input_option_button, onClick: onClick }, { children: [icon, (0, jsx_runtime_1.jsx)("span", { children: text }, void 0)] }), void 0) }), key))) }), "input-operations")) }, void 0)] }), void 0));
};
exports.default = InputOptions;
const inputOptionsVariants = {
    ul: {
        hidden: {
            opacity: 0,
            y: -10,
            transition: {
                staggerChildren: 0.07
            }
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                staggerChildren: 0.1
            }
        }
    },
    li: {
        hidden: { opacity: 0, y: -10 },
        visible: { opacity: 1, y: 0 }
    }
};
